import SellModal from './sell-modal';

export default SellModal;
